onComplete(function () {
	// Add code here.
	const isMobile = window.matchMedia("(max-width: 991px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 100 : 200;

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= PAGE_SCROLL_THRESHOLD) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})

	// Add Active state to first tab pane element

	document.querySelectorAll('.nav-tabs-sectie').forEach(section => {
		const firstTabPane = section.querySelector('.tab-content .tab-pane');
		const firstNavButton = section.querySelector('.nav-tabs > button');

		if (firstTabPane) {
			firstTabPane.classList.add('active');
		}
		if (firstNavButton) {
			firstNavButton.classList.add('active');
		}
	});

	document.querySelectorAll('.tabs-dynamisch').forEach(section => {
		const firstNavPane2 = section.querySelector('.nav-tabs > button');
		const firstTabPane2 = section.querySelector('.tab-content > .tab-pane');

		if (firstNavPane2) {
			firstNavPane2.classList.add('active');
		}
		if (firstTabPane2) {
			firstTabPane2.classList.add('active');
			firstTabPane2.classList.add('show');
		}
	});

	// DROPDOWN MENU

	const mq = window.matchMedia('(min-width: 992px)');
	const navheader = document.querySelector('.nav-header');
	const navbar = navheader.querySelector('nav.navbar');
	const dropdowns = navbar.querySelectorAll('.dropdown');
	const toggleTrigger = navheader.querySelector('[aria-expanded]');

	const isLoggedIn = () =>
		document.documentElement.dataset.logged === 'true';

	const syncMenuState = () => {
		const expanded = toggleTrigger?.getAttribute('aria-expanded') === 'true';
		navheader?.classList.toggle('menu-open', expanded);
	};

	const closeAll = () => {
		dropdowns.forEach(d => {
			d.classList.remove('show');
			d.querySelector('.dropdown-menu')?.classList.remove('show');
		});
		if (toggleTrigger) toggleTrigger.setAttribute('aria-expanded', 'false');
		syncMenuState();
	};

	const openDropdown = (element) => {
		if (!mq.matches) return;

		closeAll();

		const menu = element.querySelector('.dropdown-menu');

		element.classList.add('show');
		menu?.classList.add('show');

		if (toggleTrigger) toggleTrigger.setAttribute('aria-expanded', 'true');

		syncMenuState();
	};

	dropdowns.forEach(dropdown => {
		const menu = dropdown.querySelector('.dropdown-menu');

		if (menu) {
			menu.addEventListener('click', e => {
				e.stopPropagation();
			});
		}
	});

	dropdowns.forEach(element => {
		const btn = element.querySelector('[data-bs-toggle="dropdown"]');

		if (btn) {
			btn.addEventListener('click', e => {
				e.preventDefault();

				const isOpen = element.classList.contains('show');

				if (isOpen) {
					element.classList.remove('show');
					element.querySelector('.dropdown-menu')?.classList.remove('show');
					if (toggleTrigger) toggleTrigger.setAttribute('aria-expanded', 'false');
				} else {
					openDropdown(element);
				}
			});
		}
	});

	if (!isLoggedIn()) {
		dropdowns.forEach(element => {
			element.addEventListener('mouseenter', () => openDropdown(element));

			element.addEventListener('mouseleave', e => {
				if (!element.contains(e.relatedTarget)) {
					closeAll();
				}
			});
		});
	}

	mq.addEventListener('change', e => {
		if (!e.matches) closeAll();
	});

	if (toggleTrigger) {
		const observer = new MutationObserver(syncMenuState);
		observer.observe(toggleTrigger, {
			attributes: true,
			attributeFilter: ['aria-expanded']
		});
	}

	syncMenuState();

	// No header

	const headerEl = document.querySelector('header');

	if (
		headerEl &&
		!document.querySelector('.header img') &&
		!document.querySelector('.header video') &&
		!document.querySelector('.blog-collection') &&
		!document.querySelector('.blog-item.blog-template-vacancies')
	) {
		headerEl.classList.add('no-header');
	}
});